export default __webpack_public_path__ + "static/media/streamy_awards.722b1059.svg";